module.exports = __webpack_public_path__ + "img/suggestion.4a93133.png";